import { render, staticRenderFns } from "./CompanyShipper.vue?vue&type=template&id=3090c3da&"
import script from "./CompanyShipper.vue?vue&type=script&lang=js&"
export * from "./CompanyShipper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports